import { EventEmitter } from "events";

export const authEvents = new EventEmitter();

export const AUTH_EVENTS = {
  SESSION_EXPIRED: "sessionExpired",
};
